/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalMCPRateWatchCreateRequest
 */
export interface InternalMCPRateWatchCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalMCPRateWatchCreateRequest
     */
    ownerUserId: string;
    /**
     * 
     * @type {string}
     * @memberof InternalMCPRateWatchCreateRequest
     */
    ownerClientId: string;
    /**
     * 
     * @type {number}
     * @memberof InternalMCPRateWatchCreateRequest
     */
    hotelId: number;
    /**
     * 
     * @type {Date}
     * @memberof InternalMCPRateWatchCreateRequest
     */
    checkin: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalMCPRateWatchCreateRequest
     */
    checkout: Date;
}

/**
 * Check if a given object implements the InternalMCPRateWatchCreateRequest interface.
 */
export function instanceOfInternalMCPRateWatchCreateRequest(value: object): value is InternalMCPRateWatchCreateRequest {
    if (!('ownerUserId' in value) || value['ownerUserId'] === undefined) return false;
    if (!('ownerClientId' in value) || value['ownerClientId'] === undefined) return false;
    if (!('hotelId' in value) || value['hotelId'] === undefined) return false;
    if (!('checkin' in value) || value['checkin'] === undefined) return false;
    if (!('checkout' in value) || value['checkout'] === undefined) return false;
    return true;
}

export function InternalMCPRateWatchCreateRequestFromJSON(json: any): InternalMCPRateWatchCreateRequest {
    return InternalMCPRateWatchCreateRequestFromJSONTyped(json, false);
}

export function InternalMCPRateWatchCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalMCPRateWatchCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'ownerUserId': json['owner_user_id'],
        'ownerClientId': json['owner_client_id'],
        'hotelId': json['hotel_id'],
        'checkin': (new Date(json['checkin'])),
        'checkout': (new Date(json['checkout'])),
    };
}

export function InternalMCPRateWatchCreateRequestToJSON(json: any): InternalMCPRateWatchCreateRequest {
    return InternalMCPRateWatchCreateRequestToJSONTyped(json, false);
}

export function InternalMCPRateWatchCreateRequestToJSONTyped(value?: InternalMCPRateWatchCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'owner_user_id': value['ownerUserId'],
        'owner_client_id': value['ownerClientId'],
        'hotel_id': value['hotelId'],
        'checkin': value['checkin'].toISOString().substring(0,10),
        'checkout': value['checkout'].toISOString().substring(0,10),
    };
}

